import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "bootstrap/dist/css/bootstrap.css";

import React from "react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
//import registerServiceWorker from './registerServiceWorker';

import { createStore, applyMiddleware, Store } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import reducer from "./store/reducer";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationDE from "./locale/de/translation.json";
import translationEN from "./locale/en/translation.json";
import {
  DispatchType,
  GlobalAppState,
  GlobalAppStateAction,
} from "./store/GlobalAppState";
import { FluentProvider } from "@fluentui/react-components";
import { ldTheme } from "./theme";

function Index2() {
  //const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
  const resources = {
    en: {
      translation: translationEN,
    },
    de: {
      translation: translationDE,
    },
  };

  // initialize i18next with catalog and language to use
  i18n.use(LanguageDetector).init({
    returnNull: false,
    resources,
  });

  const isDeOrEn = i18n.language.includes("de") || i18n.language.includes("en");

  if (!isDeOrEn) {
    i18n.changeLanguage("en");
  }

  let baseName = "";

  ldTheme.fontFamilyBase = "neueCond";
  ldTheme.fontSizeBase300 = "16px";

  const store: Store<GlobalAppState, GlobalAppStateAction> & {
    dispatch: DispatchType;
  } = createStore(reducer, applyMiddleware(thunk));

  return (
    <Provider store={store}>
      <FluentProvider
        style={{ backgroundColor: "rgba(250, 249, 248, 0.68)" }}
        theme={ldTheme}
      >
        <BrowserRouter basename={baseName}>
          <App />
        </BrowserRouter>
      </FluentProvider>
    </Provider>
  );
}

export default Index2;

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
//registerServiceWorker();
